export default {
      id: "user-32-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#user-32",
      toString: function () {
        return this.url;
      }
    }